import { useState } from 'react'
import {
  ImportantMessage,
  ImportantMessageInput,
  ModalDialog,
  Mtds,
  templates,
  SaveError,
  useUpdateImportantMessageMutation,
  widgets
} from 'prove-common'
import {
  importantMessageSchema,
  importantMessageUiSchema
} from '../create-important-message-modal/CreateImportantMessageModal'
import { customizeValidator, Form, IChangeEvent } from 'prove-common/rjsf'

type EditImportantMessageModalProps = {
  isOpen: boolean
  setOpen: (isOpen: boolean) => void
  message: ImportantMessage
}

export const EditImportantMessageModal = (
  props: EditImportantMessageModalProps
) => (
  <EditImportantMessageSession
    key={`${props.message.id}:${props.isOpen ? 'open' : 'closed'}`}
    {...props}
  />
)

const EditImportantMessageSession = ({
  isOpen,
  setOpen,
  message
}: EditImportantMessageModalProps) => {
  const [baselineMessage] = useState(message)
  const [formData, setFormData] = useState<ImportantMessageInput | undefined>({
    title: message.title,
    text: message.text,
    startDate: message.startDate,
    endDate: message.endDate
  })
  const updateImportantMessage = useUpdateImportantMessageMutation()
  const [saveError, setSaveError] = useState<unknown>()
  const onSubmit = ({
    formData
  }: IChangeEvent<ImportantMessageInput>): void => {
    if (formData != null && !updateImportantMessage.isPending) {
      setSaveError(undefined)
      updateImportantMessage
        .mutateAsync({
          messageId: baselineMessage.id,
          etag: baselineMessage.etag,
          body: formData
        })
        .then(() => {
          Mtds.toast.success('Meldingen er redigert')
          setOpen(false)
        })
        .catch((error) => {
          setSaveError(error)
        })
    }
  }
  const validator = customizeValidator<ImportantMessageInput>()
  return (
    <ModalDialog
      id='edit-important-message-modal'
      closedby='any'
      open={isOpen}
      onClose={() => setOpen(false)}
    >
      <Mtds.Button
        command='close'
        commandfor='edit-important-message-modal'
        aria-label='Lukk'
      />
      <Mtds.Prose>
        <Mtds.Heading>Rediger melding</Mtds.Heading>
        <SaveError error={saveError} action='redigere meldingen' />
        <Form<ImportantMessageInput>
          noHtml5Validate
          schema={importantMessageSchema}
          uiSchema={importantMessageUiSchema}
          formData={formData}
          widgets={widgets}
          templates={templates}
          showErrorList={false}
          validator={validator}
          onChange={(data) => setFormData(data.formData)}
          onSubmit={onSubmit}
        >
          <Mtds.Flex style={{ paddingTop: 'var(--mtds-8)' }}>
            <Mtds.Button
              command='close'
              commandfor='edit-important-message-modal'
            >
              Forkast
            </Mtds.Button>
            <Mtds.Button
              data-variant='primary'
              type='submit'
              aria-busy={updateImportantMessage.isPending}
              disabled={updateImportantMessage.isPending}
            >
              Lagre
            </Mtds.Button>
          </Mtds.Flex>
        </Form>
      </Mtds.Prose>
    </ModalDialog>
  )
}
